<div>
  <div class="padding-l20 header">
    <h3 class="header">
      <div *ngIf="mode===0">
        Report Manager
      </div>
      <div *ngIf="mode===1">
        Create / Edit Report
      </div>
      <label class="header-description">
        Create, Manage, Run and Delete your custom reports
      </label>
    </h3>
    <div class="padding-l20" *ngIf="mode===0">
      <div class="search-btn">
        <button mat-raised-button class="btns" color="primary" (click)="newReport()" [disabled]="disableCreateReport">Create New Report</button>
      </div>
    </div>
  </div>
  <ng-container *ngIf="mode===0">
    <div class="filter-box padding-l20">
      <div class="search-box-outer">
        <div class="filter-search-box">
          <span>
            <i class="fas fa-search report-search-icon"></i>
            <input placeholder="Search..." type="text" (input)="searchPipe.next($any($event.target).value)">
          </span>
        </div>
      </div>
    </div>
    <div class="padding-l20 tabletopsec-outer">
      <div class="tabletopsec">
        <div class="row listing-action-items">
          <div class="col-xl-4 col-lg-4 col-md-4">
          </div>
          <div class="col-xl-8 col-lg-8 col-md-8 text-right">
            <mat-paginator #filterPaginator [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-table-Container padding-l20">
      <table mat-table [dataSource]="userReportFilterDataSource" #filterTable matSort matSortDirection="desc" multiTemplateDataRows class="matTables filterTable resultTable">
        <ng-container matColumnDef="lastRunByTimeStamp">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Run Date </th>
          <td mat-cell *matCellDef="let element" class="filter-info">
            <div>
              <p>{{(element.lastRunByTimeStamp || element.createTimeStamp) | date: 'MM/dd/yyyy'}}</p>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="filterDescription">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Report Name </th>
          <td mat-cell *matCellDef="let element" class="filter-info">
            <div>
              <p>{{element.filterDescription}}</p>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="contextMenu">
          <th mat-header-cell *matHeaderCellDef class="action-header">Actions</th>
          <td mat-cell *matCellDef="let element" class="text-center">
            <div>
              <button mat-button [matMenuTriggerFor]="beforeMenu1" class="context-menu">
                <i class="fas fa-ellipsis-v"></i>
              </button>
              <mat-menu #beforeMenu1="matMenu" xPosition="before" class="context-meun-dropdown">
                <button mat-menu-item (click)="runReport(element)">Run Report</button>
                <button mat-menu-item (click)="copyReport(element)">Copy Report</button>
                <button mat-menu-item (click)="updateReport(element)">Edit Report</button>
                <button mat-menu-item (click)="deleteReport(element)">Delete Report</button>
              </mat-menu>
            </div>
          </td>
          <td mat-footer-cell *matFooterCellDef class="xs-none">  </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </ng-container>
  <ng-container *ngIf="mode===1">
    <div class="required-input-field update-filter-description report-name padding-l20">
      <mat-form-field class="wide100">
        <mat-label>Report Name :</mat-label>
        <input matInput type="text"
               name="Report Name"
               maxlength="50"
               [formControl]="reportName"
               required />
        <!--<mat-error *ngIf="description.invalid && (description.dirty || description.touched)">Please enter the report name.</mat-error>-->
        <mat-error *ngIf="reportNameUsedValidation">{{getErrorMessage()}}</mat-error>
      </mat-form-field>
    </div>
    <div class="row padding-l20 filter">
      <div class="col-md-12 padding-r0">
        <div class="chips-sec">
          <div class="row selected-chip">
            <div class="col-sm-9 col-md-10 padding-l0">
              <div>
                <mat-chip-set>
                  <mat-chip selected *ngFor="let filterValue of filterValueList">
                    {{filterValue}}
                  </mat-chip>
                </mat-chip-set>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="padding-l20 columns">
      <app-column-selector [originalDisplayedColumns]="originalDisplayedColumns" [selectedDisplayedColumns]="selectedDisplayedColumns" (selectedDisplayedColumnsEmitter)="selectDisplayedColumns($event)"></app-column-selector>
    </div>
    <div *ngIf="this.currentFilter.reportTypeId && this.currentFilter.reportTypeId == this.reportEnum.SraCostSheetReport  || this.currentFilter.reportTypeId == this.reportEnum.SraWuDeliveredCostReport" class="footer-description">
      <p>Ctrl+A to select all columns.</p>
    </div>
    <div class="filter-desc-button-sec padding-l20 buttons">
      <div class="filter-btn">
        <button mat-raised-button class="btns" [disabled]="reportName.invalid || !this.filterComponents.displayedColumns || this.filterComponents.displayedColumns?.length === 0" (click)="addReport()" [style.display]="'inline-block'" id="btnSaveFilter">Save Report</button>
      </div>
      <div class="filter-btn">
        <button mat-raised-button class="btns" [disabled]="reportName.invalid || !this.filterComponents.displayedColumns || this.filterComponents.displayedColumns?.length === 0" (click)="runReport(currentFilter)" [style.display]="'inline-block'" id="btnSaveFilter">Run Report</button>
      </div>
      <div class="filter-btn">
        <button mat-raised-button class="btns" [disabled]="reportName.invalid" *ngIf="currentFilter.userReportFilterId" (click)="deleteCurrentReport(currentFilter)" [style.display]="'inline-block'" id="btnSaveFilter">Delete Report</button>
      </div>
    </div>
  </ng-container>
</div>
